import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import EditVehicle from "@/views/Common/editVehicle.js";
export default {
    name: "Vehicle",

    extends: EditVehicle,

    props: ["clickedNext", "currentStep"],

    mixins: [validationMixin],

    data: () => {
        return {
            inputPropsPlate: null,
            inputPropsChassis: null
        };
    },

    created() {
        this.inputPropsPlate = {
            id: "vehicle__autosuggest__inputPropsPlateNo",
            placeholder: "e.g. B194DSK",
            class: "form-control",
            autocomplete: "off" // google will not propose autofill this textbox
        };
        this.inputPropsChassis = {
            id: "vehicle__autosuggest__inputPropsChassisNumber",
            placeholder: "e.g. WVWZZZ1HZRW639880",
            class: "form-control",
            name: "ChassisNumber",
            autocomplete: "off" // google will not propose autofill this textbox
        };
    },

    methods: {
        markAsTouched: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            field && field.$touch();
        },
        chkState: function(val) {
            const field = this.getDescendantProp(this.$v, val);
            return field.$dirty ? !field.$error : null;
        }
    }
};
